export default "__VITE_ASSET__Csa4Ptc9__"